export const PAPER_SORT_MODES = Object.freeze({
  MATCH_RATE: "match_rate",
  YEAR: "year",
  CITATIONS: "citations",
});

export const DEFAULT_PAPER_SORT_MODE = PAPER_SORT_MODES.MATCH_RATE;

const parseFiniteNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getPaperRelevanceScore = (paper = {}) =>
  parseFiniteNumber(paper.relevance_score) ?? 0;

export const getPaperPublicationYear = (paper = {}) =>
  parseFiniteNumber(paper.year ?? paper.pub_year);

export const getPaperCitationCount = (paper = {}) =>
  parseFiniteNumber(paper.cited_by) ?? 0;

const compareByTitle = (a = {}, b = {}) =>
  String(a.title || "").localeCompare(String(b.title || ""));

export const comparePapersByMatchRate = (a, b) => {
  const scoreDiff = getPaperRelevanceScore(b) - getPaperRelevanceScore(a);
  return scoreDiff || compareByTitle(a, b);
};

export const comparePapersByYearThenMatchRate = (a, b) => {
  const yearA = getPaperPublicationYear(a);
  const yearB = getPaperPublicationYear(b);

  if (yearA !== null && yearB !== null && yearA !== yearB) {
    return yearB - yearA;
  }
  if (yearA !== null && yearB === null) {
    return -1;
  }
  if (yearA === null && yearB !== null) {
    return 1;
  }

  return comparePapersByMatchRate(a, b);
};

export const comparePapersByCitationsThenMatchRate = (a, b) => {
  const citationDiff = getPaperCitationCount(b) - getPaperCitationCount(a);
  return citationDiff || comparePapersByMatchRate(a, b);
};

export const sortPapersForDisplay = (
  papers = [],
  sortMode = DEFAULT_PAPER_SORT_MODE,
) => {
  const comparatorByMode = {
    [PAPER_SORT_MODES.YEAR]: comparePapersByYearThenMatchRate,
    [PAPER_SORT_MODES.CITATIONS]: comparePapersByCitationsThenMatchRate,
  };
  const comparator = comparatorByMode[sortMode] || comparePapersByMatchRate;

  return [...papers].sort(comparator);
};
